
:root {
  font-family: 'DM Sans', Arial, sans-serif;
  color: #292624;
  background: #f7f4f1;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

html {
  min-width: 320px;
  min-height: 100%;
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
}

button,
input {
  font: inherit;
}

button:focus-visible,
input:focus-visible {
  outline: 2px solid #e95068;
  outline-offset: 3px;
}

#root {
  min-height: 100vh;
}
